import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    Inject,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Alert } from 'src/app/acl-data/document/document.dto';

@Component({
    templateUrl: './add-notification-dialog.component.html',
    styleUrls: ['./add-notification-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddNotificationDialogComponent {
    tempRecipient = '';
    tomorrow = new Date(new Date().setDate(new Date().getDate() + 1));

    displayedColumns: string[] = ['Action', 'Address'];
    dataSource;

    constructor(
        public dialogRef: MatDialogRef<AddNotificationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Alert
    ) {
        this.updateTable();
    }

    updateTable = () => {
        this.dataSource = new MatTableDataSource<string>(
            this.data.propertiesObj.AlertEmailAdresses
        );
    };

    onNoClick(): void {
        this.dialogRef.close();
    }

    delete = (input: string) => {
        this.data.propertiesObj.AlertEmailAdresses = this.data.propertiesObj.AlertEmailAdresses.filter(
            v => v !== input
        );

        this.updateTable();
    };

    addAddress = () => {
        if (!this.data.propertiesObj.AlertEmailAdresses) {
            this.data.propertiesObj.AlertEmailAdresses = [];
        }
        this.data.propertiesObj.AlertEmailAdresses = [
            this.tempRecipient,
            ...this.data.propertiesObj.AlertEmailAdresses,
        ];

        this.updateTable();

        this.tempRecipient = '';
    };
}
